<template>
  <LISAFormPanel
    v-if="isLISA3"
    v-bind="$attrs"
    :title="title"
    :full-height="fullHeight"
    :content-class="`lisaui:flex lisaui:flex-col lisaui:gap-2 ${contentClass ?? ''}`"
  >
    <template v-if="$slots.headerActions" #headerActions>
      <slot name="headerActions"></slot>
    </template>
    <template v-if="$slots.header" #header>
      <slot name="header"></slot>
    </template>
    <slot></slot>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </LISAFormPanel>
  <div v-else :class="`lisaui:flex lisaui:flex-col lisaui:gap-2 ${contentClass ?? ''}`">
    <b>{{ title }}</b>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { isLISA3 } from "@/composables/useLISA3";
import { LISAFormPanel } from "@fi-solutions/lisa-ui";
const {
  title = undefined,
  contentClass = undefined,
  fullHeight = true,
} = defineProps<{
  title?: string;
  contentClass?: string;
  fullHeight?: boolean;
}>();
</script>

<style lang="scss" scoped>
.form-panel {
  min-width: 0;
  min-height: 0;

  display: flex;
  flex-direction: column;
  position: relative;
}

.form-panel__header {
  flex-shrink: 0;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.75rem;
}

.form-panel__content {
  min-width: 0;
  min-height: 0;
  flex: 1;

  padding: 0.75rem;
  font-size: 1rem;
  overflow-y: auto;
}

.form-panel__footer {
  flex-shrink: 0;

  padding: 0.75rem;
  border-top: 1px solid var(--p-gray-200);
}
</style>
